<template>
    <transition
        enter-class="opacity-0"
        enter-active-class="transition-opacity duration-200"
        leave-to-class="opacity-0"
        leave-active-class="transition-opacity duration-200"
    >
      <div class="text-highlight-100">
            <div class="flex flex-wrap content-center w-full min-h-screen px-10 pt-4">
            <div v-if="ready" class="w-full">
              <div class="w-1/4 mx-auto">
                <img src="https://vuejs.simplestreamcdn.com/icons/icon-warning.png" alt="">
              </div>

              <div class="flex flex-col justify-center mx-auto mt-12 text-center content">
                <h1 class="mb-6 text-2xl font-bold">{{ _('maintenance_title') }}</h1>
              </div>

            </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapGetters } from 'vuex';
import NProgress from 'nprogress';

export default {
    computed: {
        ...mapGetters({
            fetched: 'localisation/fetched',
            _: 'localisation/translate',
            client: 'settings/getClient',
        }),
    },
    data() {
        return {
            ready: false,
            config: '',
        };
    },
    watch: {
        fetched: {
            immediate: true,
            deep: true,
            handler(fetched) {
                if (fetched) {
                    setTimeout(() => {
                        this.ready = true;
                        NProgress.done();
                    }, 1000);
                }
            },
        },
    },
    async created() {
        this.config = await import(`@/resources/${this.client}`);
    },
};
</script>

<style scoped>
.content {
  max-width: 666px;
}

.no-responsive {
  min-width: 747px;
}
</style>
